function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import isSchema from './util/isSchema';
export function create(builder) {
    return new Lazy(builder);
}
var Lazy = /*#__PURE__*/ function() {
    "use strict";
    function Lazy(builder) {
        var _this = this;
        _class_call_check(this, Lazy);
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = function(value) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var schema = _this.builder(value, options);
            if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    _create_class(Lazy, [
        {
            key: "resolve",
            value: function resolve(options) {
                return this._resolve(options.value, options);
            }
        },
        {
            key: "cast",
            value: function cast(value, options) {
                return this._resolve(value, options).cast(value, options);
            }
        },
        {
            key: "validate",
            value: function validate(value, options, maybeCb) {
                // @ts-expect-error missing public callback on type
                return this._resolve(value, options).validate(value, options, maybeCb);
            }
        },
        {
            key: "validateSync",
            value: function validateSync(value, options) {
                return this._resolve(value, options).validateSync(value, options);
            }
        },
        {
            key: "validateAt",
            value: function validateAt(path, value, options) {
                return this._resolve(value, options).validateAt(path, value, options);
            }
        },
        {
            key: "validateSyncAt",
            value: function validateSyncAt(path, value, options) {
                return this._resolve(value, options).validateSyncAt(path, value, options);
            }
        },
        {
            key: "describe",
            value: function describe() {
                return null;
            }
        },
        {
            key: "isValid",
            value: function isValid(value, options) {
                return this._resolve(value, options).isValid(value, options);
            }
        },
        {
            key: "isValidSync",
            value: function isValidSync(value, options) {
                return this._resolve(value, options).isValidSync(value, options);
            }
        }
    ]);
    return Lazy;
}();
export default Lazy;
